import { defineComponent as _defineComponent } from 'vue';
import { BModal } from "bootstrap-vue";
import { computed, ref } from "vue";
import {} from "./labels";
import LabelSelector from "./LabelSelector.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'MarkdownSelector',
    props: {
        labelTitle: null,
        labels: null,
        argumentName: null
    },
    emits: ["onOk", "onCancel"],
    setup(__props, { emit }) {
        const props = __props;
        const selectedValue = ref(undefined);
        const modalShow = ref(true);
        const title = computed(() => {
            return `Insert '${props.argumentName}'`;
        });
        const hasLabels = computed(() => {
            return props.labels && props.labels.length > 0;
        });
        function onOk() {
            emit("onOk", selectedValue.value);
        }
        function onCancel() {
            emit("onCancel");
        }
        return { __sfc: true, props, selectedValue, modalShow, title, hasLabels, emit, onOk, onCancel, BModal, LabelSelector };
    }
});
